import * as type from './types';

export function firstFiveNotifications(data) {
    return {
        type: type.GET_FIRST_FIVE_NOTIFICATIONS_REQUESTED,
        data: data,
    }
};
